import React, { useState, useEffect, useRef } from "react";
import "../../styles/EnrollSection/CountrySelect.css";

const CountrySelect = ({ onChange }) => {
  const [countries, setCountries] = useState([]);
  const [filteredCountries, setFilteredCountries] = useState([]);
  const [isOpen, setIsOpen] = useState(false);
  const [search, setSearch] = useState("");
  const [selectedCountry, setSelectedCountry] = useState(null);
  const dropdownRef = useRef(null);

  // 1. Fetch Data from API on Load
  useEffect(() => {
    fetch("https://restcountries.com/v3.1/all?fields=name,flags,idd,cca2")
      .then((res) => res.json())
      .then((data) => {
        const formattedData = data
          .map((country) => ({
            name: country.name.common,
            flag: country.flags.svg,
            code: country.cca2,
            // Handle different dial code formats safely
            dialCode:
              country.idd.root +
              (country.idd.suffixes ? country.idd.suffixes[0] : ""),
          }))
          .filter((c) => c.dialCode && !c.dialCode.includes("undefined")) // Filter invalid
          .sort((a, b) => a.name.localeCompare(b.name)); // Sort alphabetically

        setCountries(formattedData);
        setFilteredCountries(formattedData);
        
        // Set default to India (or any code you prefer)
        const defaultCountry = formattedData.find((c) => c.code === "IN");
        if (defaultCountry) setSelectedCountry(defaultCountry);
      })
      .catch((err) => console.error("Error fetching countries:", err));
  }, []);

  // 2. Handle Click Outside to Close Dropdown
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  // 3. Handle Search Filter
  useEffect(() => {
    const lowerSearch = search.toLowerCase();
    const filtered = countries.filter(
      (c) =>
        c.name.toLowerCase().includes(lowerSearch) ||
        c.dialCode.includes(lowerSearch)
    );
    setFilteredCountries(filtered);
  }, [search, countries]);

  const handleSelect = (country) => {
    setSelectedCountry(country);
    setIsOpen(false);
    setSearch(""); // Reset search on select
    if (onChange) onChange(country.dialCode); // Pass value to parent
  };

  return (
    <div className="country-select-container" ref={dropdownRef}>
      {/* Selected Value Display (The Input Box Look) */}
      <div
        className="form-control custom-input d-flex align-items-center cursor-pointer"
        onClick={() => setIsOpen(!isOpen)}
      >
        {selectedCountry ? (
          <>
            <img
              src={selectedCountry.flag}
              alt="flag"
              className="selected-flag me-2"
            />
            <span>{selectedCountry.dialCode}</span>
            <span className="ms-2 text-muted">▼</span>
          </>
        ) : (
          <span className="text-muted">Select Code</span>
        )}
      </div>

      {/* Dropdown Menu */}
      {isOpen && (
        <div className="country-dropdown-menu shadow">
          {/* Search Box inside Dropdown */}
          <div className="p-2 sticky-top bg-white border-bottom">
            <input
              type="text"
              className="form-control form-control-sm search-input"
              placeholder="Search country or code..."
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              autoFocus
            />
          </div>

          {/* Country List */}
          <ul className="list-unstyled mb-0 country-list">
            {filteredCountries.length > 0 ? (
              filteredCountries.map((country) => (
                <li
                  key={country.code}
                  className="dropdown-item d-flex align-items-center px-3 py-2"
                  onClick={() => handleSelect(country)}
                >
                  <img
                    src={country.flag}
                    alt={country.name}
                    className="list-flag me-3"
                  />
                  <span className="me-auto text-truncate country-name">
                    {country.name}
                  </span>
                  <span className="text-muted small">{country.dialCode}</span>
                </li>
              ))
            ) : (
              <li className="p-3 text-center text-muted small">
                No results found
              </li>
            )}
          </ul>
        </div>
      )}
    </div>
  );
};

export default CountrySelect;